module.exports = __webpack_public_path__ + "media/icons/ic_view-dc59bf2a.svg";